import { abilitiesPlugin } from '@casl/vue'
import { ability } from '~/composables/useRolePermissions'

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.use(abilitiesPlugin, ability)
})
